import { InjectionToken } from '@angular/core';

export const CLIENTSERVICE = new InjectionToken<any>('CLIENTSERVICE');
export const SCREENMAPPER = new InjectionToken<any>('SCREENMAPPER');
export const ENVIRONMENT = new InjectionToken<any>('ENVIRONMENT');
export const JWT_TOKEN_KEY = new InjectionToken<string>('JWT_TOKEN_KEY');
